import { render, staticRenderFns } from "./BrowseBar.vue?vue&type=template&id=3b455136&"
import script from "./BrowseBar.vue?vue&type=script&lang=js&"
export * from "./BrowseBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports